import React, { Component } from 'react';
import { Query } from 'react-apollo';
import PropTypes from 'prop-types';

import Loading from '../../Components/Loading';
import { query, converter2 } from '../../GraphQL/query/UniFaculty.query';

import FacultyList from './FacultyList';

class FacultyListGQL extends Component {
  render() {
    const { universityId } = this.props;
    const { data } = require(`../../data/university/${universityId}.json`);
    const faculties = data.university.faculties || [];
    return <FacultyList data={faculties.map(converter2(universityId))} {...this.props} />;
  }
}

FacultyListGQL.propTypes = {
  eduTag: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  universityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default FacultyListGQL;
